module.exports = __webpack_public_path__ + "img/tt.8ab31263.svg";